import { render, staticRenderFns } from "./points-rule.vue?vue&type=template&id=1b3f5bdc&scoped=true"
import script from "./points-rule.vue?vue&type=script&lang=js"
export * from "./points-rule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3f5bdc",
  null
  
)

export default component.exports